import { Observable, throwError } from 'rxjs';
import { Injectable, ErrorHandler } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from './../.././../environments/environment';

// Base API service. This allows us to centralize all http operations so we can
// have a consistent experience as well as handle errors in a central location.
@Injectable()
export class ApiService {
  constructor(public http: HttpClient, private errorHandler: ErrorHandler) {}

  get<T>(url: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http
      .get<T>(this.path(url), { params })
      .pipe(catchError((e) => this.formatErrors(e)));
  }

  post<T>(url: string, body: T): Observable<any> {
    return this.http
      .post<T>(this.path(url), body)
      .pipe(catchError((e) => this.formatErrors(e)));
  }

  patch<T>(url: string, body: T): Observable<any> {
    return this.http
      .patch<T>(this.path(url), body)
      .pipe(catchError((e) => this.formatErrors(e)));
  }

  put<T>(url: string, body: T): Observable<any> {
    return this.http
      .put<T>(this.path(url), body)
      .pipe(catchError((e) => this.formatErrors(e)));
  }

  delete(url: string): Observable<any> {
    return this.http
      .delete(this.path(url))
      .pipe(catchError((e) => this.formatErrors(e)));
  }

  protected path(url: string): string {
    return `${environment.api_url}/${url}`;
  }

  private formatErrors(error: any) {
    this.errorHandler.handleError(error); // Default error handler, will dump to console
    return throwError(error.error);
  }
}
